import { render, staticRenderFns } from "./BaseRouterView.vue?vue&type=template&id=63ed9fd4&scoped=true&"
import script from "./BaseRouterView.vue?vue&type=script&lang=ts&"
export * from "./BaseRouterView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ed9fd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/app-root/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63ed9fd4')) {
      api.createRecord('63ed9fd4', component.options)
    } else {
      api.reload('63ed9fd4', component.options)
    }
    module.hot.accept("./BaseRouterView.vue?vue&type=template&id=63ed9fd4&scoped=true&", function () {
      api.rerender('63ed9fd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/GPortal/Frontend/vue/view/app/BaseRouterView.vue"
export default component.exports